import moment from '../moment';

export const formatStudent = (student) => ({
	...student,
	lastNameAndInsertion: student.insertion
		? `${student.lastName}, ${student.insertion}`
		: student.lastName,
	dateOfBirth: student.dateOfBirth ? moment(student.dateOfBirth).format('L') : undefined,
	dateOfBirthSort: student.dateOfBirth,
});
